<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-alarm-off`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.192 2.707l1.415 1.414a1 1 0 010 1.415l-7.071 7.07a1 1 0 01-1.415 0l-1.414-1.413a1 1 0 010-1.415l7.071-7.07a1 1 0 011.414 0zM24 6c9.643 0 17.691 6.824 19.58 15.906a15.893 15.893 0 00-4.637-1.636C36.639 14.264 30.818 10 24 10c-8.837 0-16 7.163-16 16 0 7.831 5.626 14.348 13.056 15.73a15.978 15.978 0 002.448 4.263C12.687 45.73 4 36.88 4 26 4 14.954 12.954 6 24 6zm12 18c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12zm-6.892 7.936l10.956 10.956a8 8 0 01-10.956-10.956zM36 28a7.964 7.964 0 00-4.064 1.108l10.956 10.956A8 8 0 0036 28zM26 17a1 1 0 00-1-1h-2a1 1 0 00-1 1v10c0 .283.117.538.306.72A16.082 16.082 0 0126 23.51L26 17zm19.607-7.222l-7.072-7.07a1 1 0 00-1.414 0L35.707 4.12a1 1 0 000 1.415l7.071 7.07a1 1 0 001.414 0l1.415-1.413a1 1 0 000-1.415z"/></svg>
</template>
<script>

export default {
  name: 'IconAlarmOff',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
